module.exports = __webpack_public_path__ + "static/img/library.f95ae29b.png";